module.exports = __webpack_public_path__ + "static/media/tech-icon-tv.d2dca108.svg";